<template>
  <AppHeader />
  <main class="pt-[129px] pb-[43px] bg-background min-h-screen">
    <RegisterServiceForm />
  </main>
</template>

<script>
import AppHeader from "@/components/common/Header.vue";
import RegisterServiceForm from "@/components/Services/RegisterServiceForm.vue";

export default {
  name: "SpaceRegistry",
  metaInfo: {
    title: "Space Registry | Biglo",
  },
  components: {
    AppHeader,
    RegisterServiceForm,
  },
};
</script>

<style scoped></style>
